/**
 * The landing templates a Training can be rendered with. `Training.template`
 * stores one of these keys; src/routes/training/$slug.tsx picks the component
 * and the Trainings admin uses the labels for its dropdown.
 *
 * Kept in a .ts file with no JSX so both the route and the admin page can
 * import the list without pulling a template's component tree along with it.
 */
export const TEMPLATE_KEYS = ["default", "video"] as const;

export type TemplateKey = (typeof TEMPLATE_KEYS)[number];

export const DEFAULT_TEMPLATE: TemplateKey = "default";

/** Arabic labels — the admin UI is Arabic-only. */
export const TEMPLATE_LABELS: Record<TemplateKey, string> = {
	default: "الافتراضي — صورة المدرّب",
	video: "بالفيديو — عمودي (9:16)",
};

/** Narrows a raw DB string, so an unknown/legacy value renders the default. */
export function asTemplateKey(value: string | null | undefined): TemplateKey {
	return TEMPLATE_KEYS.includes(value as TemplateKey)
		? (value as TemplateKey)
		: DEFAULT_TEMPLATE;
}
